import { render, staticRenderFns } from "./ShippingManage.vue?vue&type=template&id=e6c26566&scoped=true&"
import script from "./ShippingManage.vue?vue&type=script&lang=js&"
export * from "./ShippingManage.vue?vue&type=script&lang=js&"
import style0 from "./ShippingManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShippingManage.vue?vue&type=style&index=1&id=e6c26566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c26566",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VCombobox,VExpandTransition,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6c26566')) {
      api.createRecord('e6c26566', component.options)
    } else {
      api.reload('e6c26566', component.options)
    }
    module.hot.accept("./ShippingManage.vue?vue&type=template&id=e6c26566&scoped=true&", function () {
      api.rerender('e6c26566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Shipping/components/ShippingManage/ShippingManage.vue"
export default component.exports